export async function useSheerId() {
  const [sheerId] = await Promise.all([import('@sheerid/jslib'), import('@sheerid/jslib/sheerid.css')]);

  return sheerId;
}
